// extracted by mini-css-extract-plugin
module.exports = {"video":"youtube-modal_video__GrxzN","close":"youtube-modal_close__HURA_","show":"youtube-modal_show__u3y8c"};